import QuestionnaireInput from './QuestionnaireInput'
import QuestionnaireButton from './QuestionnaireButton'
import Questionnaire from './Questionnaire'

export default {
  install(Vue, options) {
    Vue.component(QuestionnaireInput.name, QuestionnaireInput)
    Vue.component(QuestionnaireButton.name, QuestionnaireButton)
    const questionnaire = new Questionnaire()
    Object.defineProperty(Vue.prototype, '$questionnaire', { get: function() {
      questionnaire.vm = this
      return questionnaire
    }})
  }
}


// WEBPACK FOOTER //
// ./src/Questionnaire/index.js